import '@mui/material/styles/styled';

import React from 'react';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import Root from 'containers/Root';
import ApiProvider from 'modules/Api/ApiContext';
import I18nUpdater from 'modules/Translation/i18n';
import { AppProvider } from 'store/AppContext';

const { VITE_BUGSNAG_API_KEY } = import.meta.env;

Bugsnag.start({
    apiKey: VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

ReactDOM.createRoot(document.getElementById('root')).render(
    <AppProvider>
        <ApiProvider>
            <BrowserRouter>
                <I18nUpdater />
                <ErrorBoundary>
                    <Root />
                </ErrorBoundary>
            </BrowserRouter>
        </ApiProvider>
    </AppProvider>
);
